import { fetchAndParse } from '../../ts/utils/ajax';
import type { FeatureFlagAPI } from '../types/featureFlags';
/**
 * Do not use getTenantId from '../utils/tenant' here.
 * Feature flags control the behaviour of the application.
 * We need to make sure the caller of these API requests
 * has a tenant ID to ensure the correct behaviour
 * for a tenant.
 */

export const getFeatureFlags = (tenantId: string) =>
    fetchAndParse<FeatureFlagAPI[]>({
        url: '/api/features/1/tenant',
        method: 'GET',
        headers: {
            ManyWhoTenant: tenantId,
        },
    });

export const enableFeatureFlag = ({
    tenantId,
    featureFlagId,
    enabled,
}: {
    tenantId: string;
    featureFlagId: string;
    enabled: boolean;
}) =>
    fetchAndParse<void>({
        url: '/api/features/1/tenant',
        method: 'PUT',
        headers: {
            ManyWhoTenant: tenantId,
            'Content-Type': 'application/json',
        },
        body: {
            featureFlagId,
            enabled,
        },
    });
